import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';

import NumberSetting from 'hb-builder/components/common/SettingsLibrary/CommonSettings/NumberSetting';
import type { ComponentSettingsTab } from 'hb-builder/types/settings';
import type { SpacerItemAttributes } from 'hb-react/backoffice/types/builder/itemAttributes/spacerItemAttributes';

const SpacerSettings = (
  settingProps: ComponentSettingsTab<SpacerItemAttributes>,
) => (
  <Wrapper>
    <NumberSetting
      settingKey="spacerHeight"
      title={__('Spacing in pixels')}
      {...settingProps}
    />
  </Wrapper>
);

export default SpacerSettings;

const Wrapper = styled(Box).attrs(() => ({
  flexDirection: 'column',
  padding: '20px',
  width: '100%',
}))``;
